"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arpino": {
    "forglieta": [{
      "hkey": "50899f49",
      "slug": "arpino",
      "name": "Arpino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce249a57": [{
      "hkey": "50899f49",
      "slug": "arpino",
      "name": "Arpino",
      "primary": true,
      "skipSearch": false
    }],
    "db355636": [{
      "hkey": "50899f49",
      "slug": "arpino",
      "name": "Arpino",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "50899f49",
      "slug": "arpino",
      "name": "Arpino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "28ca52f1": [{
      "hkey": "f4f2e526",
      "slug": "abate-vallefredda",
      "name": "Abate-Vallefredda",
      "primary": true,
      "skipSearch": false
    }],
    "vallefredda": [{
      "hkey": "f4f2e526",
      "slug": "abate-vallefredda",
      "name": "Abate-Vallefredda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;